import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Banks;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { Heading } from '@instructure/ui-heading';
import { Img } from '@instructure/ui-img';
import { AccessibleContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import { IconPlusLine, IconArrowUpLine, IconArrowDownLine } from '@instructure/ui-icons';
import { Billboard } from '@instructure/ui-billboard';
import { Button } from '@instructure/ui-buttons';
import { jsx } from '@instructure/emotion';
import { Grid } from '@instructure/ui-grid';
import { View } from '@instructure/ui-view';
import debounce from 'lodash/fp/debounce';
import Page from '../../../common/components/layout/Page';
import { HeaderBreadCrumb } from '../HeaderBreadCrumb';
import PaginatedCollection from '../../../common/components/shared/PaginatedCollection';
import t from '@instructure/quiz-i18n/format-message';
import { BANKS_BANK_FILTERS, BANKS_BANK_PAGINATION, CREATE_BANK_MODAL, SHARED_WITH_ACCOUNT, withStyleOverrides, SimpleSelect, TextInput } from '@instructure/quiz-common';
import BanksList from '../../../banks/components/BanksList';
import CreateBankModal from '../../../banks/components/CreateBankModal';
import NavWrapper from '../NavWrapper';
import noResults from '../noResults.svg';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import AsyncSearch from '../AsyncSearch';
var sortOrderIcons = {
  ascending: IconArrowUpLine,
  descending: IconArrowDownLine
};
export var Banks = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Banks = /*#__PURE__*/function (_Component) {
  function Banks(props) {
    var _this2;
    _classCallCheck(this, Banks);
    _this2 = _callSuper(this, Banks, arguments);
    // We only care about displaying the account search for the Institution Banks and Shared with Me filters
    _defineProperty(_this2, "hideAccountSearch", function () {
      if (_this2.props.scopeType === 'course' || _this2.props.scopeType === 'courses' || _this2.props.scopeType === 'this_account') {
        return true;
      }
      return false;
    });
    _defineProperty(_this2, "isSubAccountLaunch", function () {
      return _this2.props.scope.type === 'account' && _this2.props.scope.launch_context_uuid && _this2.props.rootAccountUuid && _this2.props.scope.launch_context_uuid !== _this2.props.rootAccountUuid;
    });
    _defineProperty(_this2, "onCreateBank", function () {
      _this2.props.createBank({
        language: _this2.context.locale
      });
      _this2.props.openModal(CREATE_BANK_MODAL, {
        modalTrigger: _this2.createBankButton,
        onCreateBank: _this2.handleBankCreated
      });
    });
    _defineProperty(_this2, "handleBankCreated", function () {
      _this2.props.merge(BANKS_BANK_FILTERS, {
        scopeType: 'user'
      });
    });
    _defineProperty(_this2, "getBanksParams", function () {
      var scope = _this2.props.scope;
      var params = {};
      if (_this2.props.scopeType === 'course' && scope.uuid) {
        params['course_id'] = scope.uuid;
      } else if (_this2.props.scopeType && _this2.props.scopeType != 'user') {
        params['scope'] = _this2.props.scopeType;
      }
      if (_this2.props.sortBy !== 'name') {
        params['sort_by'] = _this2.props.sortBy;
      }
      if (_this2.props.sortOrder === 'descending') {
        params['sort_order'] = 'DESC';
      }
      if (_this2.props.searchTerms) {
        params['search'] = _this2.props.searchTerms;
      }
      if (_this2.props.scopeType === 'this_account') {
        params['account_uuids'] = [_this2.props.scope.launch_context_uuid];
        params['scope'] = 'account';
      } else if (_this2.props.searchSelection.length > 0) {
        params['account_uuids'] = _this2.props.searchSelection.map(function (account) {
          return account.uuid;
        });
      }
      return params;
    });
    _defineProperty(_this2, "getPage", function (page) {
      var params = _this2.getBanksParams();
      return _this2.props.getBanks(_objectSpread({
        page: page
      }, params), _this2.props.usedByCourseEnabled, _this2.props.getCourseAssignments);
    });
    _defineProperty(_this2, "focusCreateBankButton", function () {
      _this2.createBankButton && _this2.createBankButton.focus();
    });
    _defineProperty(_this2, "handleCreateBankButtonRef", function (node) {
      _this2.createBankButton = node;
    });
    _defineProperty(_this2, "handleBanksParentChange", function (event, _ref) {
      var scopeType = _ref.value;
      _this2.props.merge(BANKS_BANK_FILTERS, {
        scopeType: scopeType
      });
    });
    _defineProperty(_this2, "getSortingOrderIcon", function () {
      return sortOrderIcons[_this2.props.sortOrder];
    });
    _defineProperty(_this2, "getSortAssistiveText", function () {
      return t('Change sort direction. Direction is currently { sortDirection }', {
        sortDirection: _this2.props.sortOrder === 'ascending' ? t('ascending') : t('descending')
      });
    });
    _defineProperty(_this2, "handleSortingButtonClick", function () {
      _this2.props.merge(BANKS_BANK_FILTERS, {
        sortOrder: _this2.props.sortOrder === 'ascending' ? 'descending' : 'ascending'
      });
    });
    _defineProperty(_this2, "handleSortByChange", function (event, _ref2) {
      var sortBy = _ref2.value;
      _this2.props.merge(BANKS_BANK_FILTERS, {
        sortBy: sortBy
      });
    });
    _defineProperty(_this2, "handleTableSortChange", function (sortBy, sortOrder) {
      return function () {
        var newSortOrder = sortOrder;
        if (_this2.props.sortBy === sortBy) {
          // toggle sort order
          sortOrder === 'ascending' ? newSortOrder = 'descending' : newSortOrder = 'ascending';
        }
        _this2.props.merge(BANKS_BANK_FILTERS, {
          sortOrder: newSortOrder,
          sortBy: sortBy
        });
      };
    });
    _defineProperty(_this2, "handleSearchInputChange", function (_ref3) {
      var value = _ref3.target.value;
      _this2.setState({
        searchTerms: value
      });
      _this2.search(value);
    });
    _defineProperty(_this2, "handleSearchSelectionChange", function (searchSelection) {
      _this2.props.setUI([BANKS_BANK_FILTERS, 'searchSelection'], searchSelection);
    });
    _defineProperty(_this2, "renderRecords", function (recordIds) {
      return jsx(BanksList, {
        createBankButton: _this2.createBankButton,
        currentUser: _this2.props.currentUser,
        focusCreateBankButton: _this2.focusCreateBankButton,
        getCourseInfo: _this2.props.getCourseInfo,
        getUserInfo: _this2.props.getUserInfo,
        getSubaccountInfo: _this2.props.getSubaccountInfo,
        getShareableCourses: _this2.props.getShareableCourses,
        getShareableUsers: _this2.props.getShareableUsers,
        getShareableSubaccounts: _this2.props.getShareableSubaccounts,
        isCompact: _this2.props.isCompact,
        itemBankSearchTableEnabled: _this2.props.itemBankSearchTableEnabled,
        minChars: _this2.props.minChars,
        navigateToBank: _this2.props.navigateToBank,
        onChangeSort: _this2.handleTableSortChange,
        onShare: _this2.props.onShare,
        order: _this2.props.sortOrder,
        recordIds: recordIds,
        sort: _this2.props.sortBy
      });
    });
    _defineProperty(_this2, "emptyPage", function () {
      if (_this2.props.searchTerms || _this2.props.searchSelection.length > 0) {
        var message;
        if (_this2.props.scopeType === 'course') {
          message = t("Your filter is set to \"Courses\" which will narrow what you can search for.\n          Try adjusting the filter to \"{ topLevelBankFilter }\"", {
            topLevelBankFilter: _this2.topLevelBankFilterName()
          });
        } else if (_this2.props.scopeType === 'this_account') {
          message = t("Your filter is set to \"This Account\" which will narrow what you can search for.\n            Try adjusting the filter to \"{ topLevelBankFilter }\"", {
            topLevelBankFilter: _this2.topLevelBankFilterName()
          });
        } else if (_this2.props.scopeType === 'account') {
          message = t("Your filter is set to \"Institution\" which will narrow what you can search for.\n          Try adjusting the filter to \"{ topLevelBankFilter }\"", {
            topLevelBankFilter: _this2.topLevelBankFilterName()
          });
        }
        return jsx(Billboard, {
          size: "medium",
          heading: t('No Results Found'),
          message: message,
          hero: jsx(Img, {
            src: noResults
          })
        });
      }
      return t("You don't have any banks yet");
    });
    _this2.state = {
      searchTerms: _this2.props.searchTerms || ''
    };
    _this2.search = debounce(500, function (searchTerms) {
      _this2.props.merge(BANKS_BANK_FILTERS, {
        searchTerms: searchTerms
      });
    });
    return _this2;
  }
  _inherits(Banks, _Component);
  return _createClass(Banks, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.sortBy !== this.props.sortBy || prevProps.sortOrder !== this.props.sortOrder || prevProps.searchTerms !== this.props.searchTerms || prevProps.scopeType !== this.props.scopeType || !isEqual(prevProps.searchSelection, this.props.searchSelection)) {
        this.props.clear(BANKS_BANK_PAGINATION);
      }
    }
  }, {
    key: "topLevelBankFilterName",
    value: function topLevelBankFilterName() {
      return t('Shared with Me');
    }
  }, {
    key: "renderFilters",
    value: function renderFilters() {
      var scopeOptions = [{
        slug: 'user',
        translation: this.topLevelBankFilterName()
      }, {
        slug: 'account',
        translation: t('Institution Banks')
      }, {
        slug: 'courses',
        translation: t('Shared with Courses')
      }];
      if (this.props.scope.uuid) {
        scopeOptions.push({
          slug: 'course',
          translation: t('This Course')
        });
      }
      if (this.isSubAccountLaunch()) {
        // Put this option below "Insitution Banks"
        scopeOptions.splice(2, 0, {
          slug: 'this_account',
          translation: t('This Account')
        });
      }

      // display options are displayed when using banks list
      // non-display options are used for sorting of banks table
      var sortingCriteriaOptions = [{
        slug: 'name',
        translation: t('Bank Name'),
        display: true
      }, {
        slug: 'last_used',
        translation: t('Last Used'),
        display: true
      }, {
        slug: 'updated_at',
        translation: t('Last Updated'),
        display: true
      }, {
        slug: 'created_at',
        translation: t('Created Date'),
        display: false
      }];
      var searchFiltersSelectOptionIdPrefix = 'banks-search-filters-select-option-';
      var searchFilters = jsx(View, {
        as: "div",
        width: "100%"
      }, jsx(Grid, {
        startAt: "medium",
        colSpacing: "small",
        rowSpacing: "small",
        vAlign: "bottom"
      }, jsx(Grid.Row, null, jsx(Grid.Col, {
        width: "auto"
      }, jsx(SimpleSelect, {
        onChange: this.handleBanksParentChange,
        value: this.props.scopeType,
        renderLabel: t('Filter By'),
        width: "13rem",
        "data-automation": "sdk-banks-filter-select"
      }, scopeOptions.map(function (option) {
        return jsx(SimpleSelect.Option, {
          id: searchFiltersSelectOptionIdPrefix + option.slug,
          key: option.slug,
          value: option.slug
        }, option.translation);
      }))), jsx(Grid.Col, {
        width: 4
      }, jsx(TextInput, {
        renderLabel: t('Bank'),
        type: "search",
        value: this.state.searchTerms,
        onChange: this.handleSearchInputChange,
        placeholder: t('Search Banks'),
        "data-automation": "sdk-search-bank-textinput"
      })), !this.hideAccountSearch() && jsx(Grid.Col, {
        width: 4
      }, jsx(AsyncSearch, {
        getShareableSubaccounts: this.props.getShareableSubaccounts,
        minChars: this.props.minChars,
        onSelectionChange: this.handleSearchSelectionChange,
        searchType: SHARED_WITH_ACCOUNT,
        selectedOption: this.props.searchSelection,
        searchLabel: t('Account'),
        placeholderLabel: t('Search Accounts')
      })))));
      var sortingFiltersSelectOptionIdPrefix = 'banks-sorting-filters-select-option-';
      var sortingFilters = jsx(React.Fragment, null, jsx("div", {
        display: "inline-block",
        style: {
          margin: 'auto 0px auto auto'
        }
      }, jsx(SimpleSelect, {
        renderLabel: jsx(ScreenReaderContent, null, t('Sort by')),
        value: this.props.sortBy,
        width: "10rem",
        onChange: this.handleSortByChange
      }, sortingCriteriaOptions.filter(function (option) {
        return option.display === true;
      }).map(function (option) {
        return jsx(SimpleSelect.Option, {
          id: sortingFiltersSelectOptionIdPrefix + option.slug,
          key: option.slug,
          value: option.slug
        }, option.translation);
      }))), jsx("div", {
        display: "inline-block",
        style: {
          marginLeft: '1rem'
        }
      }, jsx(Button, {
        type: "button",
        onClick: this.handleSortingButtonClick,
        "data-automation": "sdk-sort-banks-button",
        renderIcon: this.getSortingOrderIcon()
      }, jsx(AccessibleContent, {
        alt: this.getSortAssistiveText()
      }, t('Sort')))));
      if (this.props.closeTray) {
        return jsx("div", {
          css: [this.props.styles.filters, this.props.styles.borderedBottom]
        }, jsx("div", {
          css: this.props.styles.filtersRow
        }, searchFilters), !this.props.itemBankSearchTableEnabled && jsx("div", {
          css: this.props.styles.filtersRow
        }, sortingFilters));
      } else {
        return jsx("div", {
          css: [this.props.styles.filters, this.props.styles.borderedBottom]
        }, jsx("div", {
          css: this.props.styles.filtersRow
        }, searchFilters, !this.props.itemBankSearchTableEnabled && sortingFilters));
      }
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return jsx("div", {
        css: [this.props.styles.header]
      }, jsx(Heading, {
        as: this.props.isCompact ? 'h2' : 'h1',
        level: "h1"
      }, t('Banks')), jsx(Button, {
        ref: this.handleCreateBankButtonRef,
        type: "button",
        color: "primary",
        onClick: this.onCreateBank,
        "data-automation": "sdk-create-new-bank-button",
        renderIcon: IconPlusLine
      }, jsx(AccessibleContent, {
        alt: t('Create Bank')
      }, t('Bank'))));
    }
  }, {
    key: "renderNav",
    value: function renderNav() {
      var _this$props = this.props,
        scope = _this$props.scope,
        closeTray = _this$props.closeTray,
        navigateToBuild = _this$props.navigateToBuild,
        returnToUrl = _this$props.returnToUrl;
      var isScopeEmpty = !Object.keys(scope).length;
      return jsx(NavWrapper, {
        closeTray: closeTray,
        navigateToBuild: navigateToBuild,
        returnToUrl: isScopeEmpty ? null : returnToUrl,
        scope: scope,
        isCompact: this.props.isCompact,
        iceTopNavBarEnabled: this.props.iceTopNavBarEnabled,
        menuItemPath: "/banks"
      });
    }
  }, {
    key: "renderBanksSearchResults",
    value: function renderBanksSearchResults() {
      return jsx(PaginatedCollection, {
        empty: this.emptyPage(),
        getPage: this.getPage,
        renderRecords: this.renderRecords,
        stateKey: BANKS_BANK_PAGINATION
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Page, null, this.renderNav(), jsx("div", {
        css: this.props.styles.content
      }, this.props.iceTopNavBarEnabled && jsx("div", {
        css: this.props.styles.breadcrumb
      }, jsx(HeaderBreadCrumb, {
        returnToUrl: this.props.returnToUrl,
        scope: this.props.scope,
        navigateToBuild: this.props.navigateToBuild
      })), this.renderHeader(), this.renderFilters(), this.renderBanksSearchResults(), jsx(CreateBankModal, {
        itemBanksScope: this.props.scope
      })));
    }
  }]);
}(Component), _defineProperty(_Banks, "displayName", 'Banks'), _defineProperty(_Banks, "componentId", "Quizzes".concat(_Banks.displayName)), _defineProperty(_Banks, "propTypes", {
  closeTray: PropTypes.func,
  createBank: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    bank_admin: PropTypes.bool,
    can_share_banks_with_subaccounts: PropTypes.bool,
    email: PropTypes.string,
    enrollment_names: PropTypes.arrayOf(PropTypes.string),
    full_name: PropTypes.string,
    uuid: PropTypes.string,
    account_name: PropTypes.string
  }),
  // from consumer
  clear: PropTypes.func.isRequired,
  getBanks: PropTypes.func.isRequired,
  getCourseInfo: PropTypes.func,
  // from consumer
  getUserInfo: PropTypes.func,
  // from consumer
  getShareableCourses: PropTypes.func,
  // from consumer
  getShareableUsers: PropTypes.func,
  // from consumer
  getShareableSubaccounts: PropTypes.func,
  // from consumer
  getSubaccountInfo: PropTypes.func,
  // from consumer
  getCourseAssignments: PropTypes.func,
  // from consumer
  isCompact: PropTypes.bool,
  merge: PropTypes.func.isRequired,
  minChars: PropTypes.number,
  navigateToBank: PropTypes.func.isRequired,
  // can be from consumer
  navigateToBuild: PropTypes.func,
  // from consumer
  onShare: PropTypes.func,
  // from consumer
  openModal: PropTypes.func.isRequired,
  returnToUrl: PropTypes.string,
  // from consumer
  scope: PropTypes.shape({
    type: PropTypes.string,
    uuid: PropTypes.string,
    title: PropTypes.string,
    launch_context_uuid: PropTypes.string,
    root_account_name: PropTypes.string
  }).isRequired,
  scopeType: PropTypes.string,
  searchTerms: PropTypes.string,
  searchSelection: PropTypes.arrayOf(PropTypes.shape({
    avatar: PropTypes.string,
    fullName: PropTypes.string,
    title: PropTypes.string,
    uuid: PropTypes.string.isRequired
  })),
  sortBy: PropTypes.string,
  sortOrder: PropTypes.string,
  usedByCourseEnabled: PropTypes.bool,
  itemBankSearchTableEnabled: PropTypes.bool,
  setUI: PropTypes.func.isRequired,
  iceTopNavBarEnabled: PropTypes.bool,
  styles: PropTypes.object,
  rootAccountUuid: PropTypes.string
}), _defineProperty(_Banks, "defaultProps", {
  closeTray: null,
  currentUser: null,
  getCourseInfo: null,
  getUserInfo: null,
  getShareableCourses: null,
  getShareableUsers: null,
  getCourseAssignments: null,
  getShareableSubaccounts: null,
  getSubaccountInfo: null,
  minChars: void 0,
  isCompact: false,
  navigateToBuild: null,
  onShare: function onShare() {},
  scope: {},
  returnToUrl: null,
  scopeType: 'user',
  sortBy: 'name',
  sortOrder: 'ascending',
  searchTerms: null,
  searchSelection: [],
  usedByCourseEnabled: false,
  itemBankSearchTableEnabled: false,
  iceTopNavBarEnabled: false,
  rootAccountUuid: null
}), _defineProperty(_Banks, "contextTypes", {
  locale: PropTypes.string
}), _Banks)) || _class);
export default Banks;